export default __webpack_public_path__ + "static/media/Emotional01.00884a25.png";